import { atom } from "recoil";

export const TagsMoreActionsPopOverLoadingAtom = atom<boolean>({
  key: "TagsMoreActionsPopOverLoadingAtom",
  default: false,
});

export const CategoriesMoreActionsPopOverLoadingAtom = atom<boolean>({
  key: "CategoriesMoreActionsPopOverLoadingAtom",
  default: false,
});
